export default __webpack_public_path__ + "static/media/MapIcon.c8f3df96.svg";